import {TextInputField, TextInputFieldProps} from 'evergreen-ui';
import React from 'react';
import {FieldError, useFormContext, RegisterOptions} from 'react-hook-form';
import {ValidationMessage} from './ValidationMessage';


export type ValidatedTextInputFieldProps<T> = {
    validationRules?: RegisterOptions,
    name: keyof T,
    /**
     * Reshapes what the user types before the form reads it, for a field with a fixed shape such
     * as a phone. The input shows the reshaped value, and validation runs on it.
     */
    shapeValue?: (value: string) => string,
} & Omit<TextInputFieldProps, 'name'>;
export const ValidatedTextInputField = <T extends Record<string, any>, >
({
     validationRules,
     name,
     shapeValue,
     ...rest
 }: ValidatedTextInputFieldProps<T>
) => {
    const {
        register,

        formState: {
            errors,
        },
    } = useFormContext<T>();
    // @ts-ignore
    const registration = register(name.toString(), validationRules);
    // react-hook-form 7.15 has no onChange option on register, so the shaping wraps its handler.
    const onChange = shapeValue
        ? (event: React.ChangeEvent<HTMLInputElement>) => {
            event.target.value = shapeValue(event.target.value);
            return registration.onChange(event);
        }
        : registration.onChange;
    return (
        <TextInputField
            {...rest}
            {...registration}
            onChange={onChange}
            // @ts-ignore
            isInvalid={!!errors[name]}
            // @ts-ignore
            validationMessage={<ValidationMessage error={errors[name] as FieldError | undefined}/>}/>
    );
}
